import ArrowLeftIcon from "@/app/_components/Icons/ArrowLeftIcon";
import CircleForBanner from "@/app/_components/Icons/CircleForBanner";
import { Box, Card, CardActionArea, Icon, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import NextLink from "next/link";
type Props = {
  title?: ReactNode | string;
  btnColor?: string;
  backgroundColor?: string;
  btnTitle?: string;
  backgroundColor2?: string;
  circleColor?: string;
  img?: string;
  height?: number;
  ltr?: boolean;
  href?: string;
};
export default function DesktopBanner(props: Props) {
  const { title, btnColor, backgroundColor, backgroundColor2, btnTitle, circleColor, img, height = 180, ltr, href } = props;
  const circleSize = { md: "200px !important", xs: "150px !important" };
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "end",
        height: {
          xs: height,
          md: 280,
        },
      }}
    >
      <Card elevation={0} sx={{ position: "relative", width: "100%", height: height, borderRadius: 5, backgroundColor: backgroundColor }}>
        <Box
          sx={{
            position: "absolute",
            width: { xs: 300, md: 430 },
            height: { xs: 300, md: 430 },
            background: backgroundColor2,
            borderRadius: 100,
            ...(ltr
              ? { left: 0, transform: { md: "translateY(-50%) translateX(-25%)", xs: "translateY(-50%) translateX(-30%)" } }
              : { right: 0, transform: { md: "translateY(-50%) translateX(25%)", xs: "translateY(-50%) translateX(30%)" } }),
            top: "50%",
          }}
        ></Box>
        {circleColor && (
          <Box
            sx={{
              position: "absolute",
              // width: 430,
              // height: 430,
              borderRadius: 100,
              ...(ltr ? { left: "20%" } : { right: "20%" }),
              bottom: -25,
              // transform: "translateY(-50%) translateX(15%)",
            }}
          >
            <Icon
              sx={{
                color: circleColor,
                width: circleSize,
                height: circleSize,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "& svg": { width: circleSize, height: circleSize },
              }}
            >
              <CircleForBanner />
            </Icon>
          </Box>
        )}
        <CardActionArea
          href={href as string}
          component={NextLink}
          sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: ltr ? "end" : "start" }}
        >
          <Stack
            spacing={1}
            alignSelf={"center"}
            justifyContent={"start"}
            sx={{
              p: {
                xs: 2,
                sm: 2,
                md: 4,
              },
            }}
          >
            {title}
            <Stack direction={"row"} justifyContent={"start"} alignItems={"start"}>
              {btnTitle && (
                <Card
                  sx={{
                    borderRadius: 300,
                    backgroundColor: btnColor,
                  }}
                  elevation={0}
                >
                  <CardActionArea
                    component={"div"}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "start",
                      px: 1,
                      py: 0.5,
                      gap: 0.5,
                    }}
                  >
                    <Typography variant="body1" sx={{ color: "grey.800" }}>
                      {btnTitle}
                    </Typography>
                    <Icon fontSize="small">
                      <ArrowLeftIcon />
                    </Icon>
                  </CardActionArea>
                </Card>
              )}
            </Stack>
          </Stack>
        </CardActionArea>
      </Card>
      {img && (
        <Box
          sx={{
            position: "absolute",
            overflow: "hidden",
            ...(ltr ? { left: "2%" } : { right: "2%" }),
            bottom: 0,
            top: 0,
            pointerEvents: "none",
          }}
        >
          <Box
            component={"img"}
            src={img}
            alt="Zibasi"
            draggable={false}
            sx={{ objectFit: "contain", userSelect: "none", width: { xs: 220, md: 300 } }}
          />
        </Box>
      )}
    </Box>
  );
}
